module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MiddlePageView.js"));
	}, "MiddlePageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MiddlePageView!./src/pages/Login/MiddlePage/MiddlePageView.js
// module id = 1341
// module chunks = 418